  
  var image_swiper = new Swiper(".image-gallery-swiper", {
    grabCursor: true,
    loop: true,
    speed: 400,
    scrollbar: {
      el: ".swiper-scrollbar",
      draggable: true,
    },
    slidesPerView: 1.3,
    spaceBetween: 10,
    // Responsive breakpoints
    breakpoints: {
      375: {
        slidesPerView: 2,
        spaceBetween: 10,
        slidesPerView: 1.25,
      },
      500: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      900: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1250: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

  